import { CircularLoading } from '@foxtaibox/foxtailbox-frontend-core';
import { useGetUserQuery } from '@generated/graphql';
import { Container, Card as MuiCard, styled } from '@mui/material';
import accountImg from 'assets/images/account.png';
import useMe from 'store/user/useMe';
import UserData from './components/Data';
import UserSettings from './components/Settings';

const Card = styled(MuiCard)(({ theme }) => ({
  maxWidth: 556,
  borderRadius: 12,
  position: 'relative',
  zIndex: 1,
  padding: '30px 40px',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
}));

const ImgContainer = styled(Container)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: -45,
  width: 921,
  aspectRatio: 1 / 0.64,
  '& img': {
    maxWidth: '100%',
  },
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}));

const Account = () => {
  const { loading, data } = useGetUserQuery();
  // временный костыль для своевременной подгрузки данных при авторизации с наличием redirectUrl
  useMe();

  if (loading) return <CircularLoading />;

  const user = data?.me;

  return (
    <>
      <Card sx={{ flexGrow: { xs: 1, sm: 0 }, display: 'flex', flexDirection: 'column' }}>
        <UserData user={user} />
        <UserSettings user={user} />
      </Card>
      <ImgContainer>
        <img src={accountImg} alt='' />
      </ImgContainer>
    </>
  );
};

export default Account;
